import React from 'react';
import createRoot from 'react-dom';
import './index.css';
import App from './App';
import {BrowserRouter} from 'react-router-dom';


createRoot.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals

